
module.exports = {
	model: {
		type: 'default',
		title: {

		}
	},

	events: {
		click: function(event){
			event.preventDefault();
			event.stopImmediatePropagation();
			event.data.component.performAction();
		}
	}
};